/** Platform hint for the Cmd-K shortcut label — ⌘ on macOS, Ctrl elsewhere. Browser-only. */
export function isMac(): boolean {
  if (typeof navigator === "undefined") return false;
  const data = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  const src = data?.platform || navigator.platform || navigator.userAgent || "";
  return /mac|iphone|ipad|ipod/i.test(src);
}

/** The keyboard hint for the omnibox: "⌘K" on macOS, "Ctrl K" on Windows/Linux. */
export function cmdKLabel(): string {
  return isMac() ? "⌘K" : "Ctrl K";
}
